<template>
    <b-container>
        <Breadcrumbs crumbString="What We Do"></Breadcrumbs>
        <b-row>
            <b-col class="col-12 col-md-4 col-lg-4">
                <h2>{{ title }}</h2>
                <div>
                    enviroSIGNS offers a complete range of signage-related products and services for:
                    <ul>
                        <li><router-link :to="{ name: 'interpretive' }">Interpretive & Educational Signs</router-link></li>
                        <li><router-link :to="{ name: 'wayfinding' }">Identification & Wayfinding Signs</router-link></li>
                        <li><router-link :to="{ name: 'historical' }">Historical Signs & Markers</router-link></li>
                        <li><router-link :to="{ name: 'commemorative' }">Commemorative Signs & Plaques</router-link></li>
                    </ul>
                </div>
            </b-col>
            <b-col class="col-12 col-md-8 col-lg-8">
                <b-container class="pods-container">
                    <b-row>
                        <b-col class="col-12 col-md-6 col-lg-6">
                            <b-row>
                                <b-col class="col-12 col-md-12 col-lg-12 image-pod">
                                  <router-link :to="{ name: 'interpretive' }">
                                    <img width="100%" src="../../assets/images/pages/what-we-do/interpretive-sign-imageLOC.jpg" alt="Interpretive & Educational Signs">
                                    <span>Interpretive & Educational</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                                  <router-link :to="{ name: 'historical' }">
                                    <img width="100%" src="../../assets/images/pages/what-we-do/historical-sign-imageLOC.jpg" alt="Historical Signs">
                                    <span>Historical</span>
                                  </router-link>
                                </b-col>
                                <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                                  <router-link :to="{ name: 'commemorative' }">
                                    <img width="100%" src="../../assets/images/pages/what-we-do/commemorative-sign-novalloy.jpg" alt="Commemorative Signs">
                                    <span>Commemorative</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                          <router-link :to="{ name: 'wayfinding' }">
                            <img width="100%" src="../../assets/images/pages/what-we-do/wayfinding-sign-weathering-steel.jpg" alt="Wayfinding">
                            <span>Identification & Wayfinding</span>
                          </router-link>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  import Breadcrumbs from '../Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'What We Do'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/WhatWeDo.vue